/* ============================================================================
FILE: po-katupirsia5-usoprogalenmestud-texts-fr-en-es-20260303.js
MODE: JS FR/EN/ES (injection tri) + lexicon override (termes FR) si présent
API:  window.PoKatupirsia5UsoprogalenmestudTextsFR_EN_ES_20260303

ROLE:
  - Injecte le contenu FR/EN/ES dans les slots selon la langue choisie (localStorage).
  - Lang storage:
      - clé principale : po_lex_lang
      - clé compat :     goody_gp_lang
    Langues autorisées : fr, en, es.
  - Expose getLang(), setLang(lang), init() et stopAudio() ; déclenche po:locale-changed après bascule.
  - Écoute po:lexicon-ready pour re-render si le lexique arrive après.
  - Protection fine PRIORITAIRE : verrouille (translate="no") TOUTES les occurrences du lexique simplifié
    FR canonique via meta.lexique_simplifie_fr (si dispo), variantes apostrophes + œ/oe,
    + anti-collage (espaces DOM uniquement quand nécessaire).
  - IMPORTANT : les entrées lexicales canoniques restent en FR quelle que soit la langue affichée.
  - Ajoute une couche audio générale + audio locale par bloc, sans casser le socle existant.
============================================================================ */

(function(){
  "use strict";

  if (window.__PO_K5_USOPROGALENMESTUD_TEXTS_20260303__) return;
  window.__PO_K5_USOPROGALENMESTUD_TEXTS_20260303__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-axis-section[data-po-axis]';
  var TARGET_ID = 'usoprogalenmestud';

  var IMG_IDEOGRAM_CONCEPT = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Usoprogalenmestud_copie.png?v=1772885484';
  var IMG_ELEMENT = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535';
  var IMG_TOTEM = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekho.png?v=1773404195';
  var IMG_FREQ_225 = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/nombre_guide_225.png?v=1773409871';

  var CANON = {
    title: 'Ušôprogalenmestûd',
    page_terms: [
      'Ušôprogalenmestûd',
      'Katûpirsia',
      'Katûpirsia 5',
      'La Matrice-substrat',
      'Katûsýs',
      'La Katûvýs',
      'Katûvýs',
      'Êkhö',
      'Katûvýsissence',
      'Takimarah',
      'Tiqqunbahu',
      'Mathêsis ontologique posœnnoïale',
      'MOPo',
      'Accords posœnnoïaux',
      'RéZonans',
      'addition synchrêtique',
      'synchrêtique',
      'nombre-guide'
    ]
  };

  function clampStr(v){ return (v == null) ? '' : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, '-');
    if (s.indexOf('fr') === 0) return 'fr';
    if (s.indexOf('en') === 0) return 'en';
    if (s.indexOf('es') === 0) return 'es';
    if (s.indexOf('pt') === 0) return 'es';
    return '';
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      v = normLang(v);
      if (v) return v;
    }catch(e){}
    try{
      var v2 = localStorage.getItem(STORAGE_KEY_COMPAT);
      v2 = normLang(v2);
      if (v2) return v2;
    }catch(e){}
    return '';
  }

  var __PO_HTML_LANG_SYNC__ = false;

  function storeLang(lang){
    var v = normLang(lang) || 'fr';
    try{ localStorage.setItem(STORAGE_KEY, v); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, v); }catch(e){}
    try{
      if (document && document.documentElement){
        var currentLang = normLang(document.documentElement.getAttribute('lang') || '') || '';
        if (currentLang !== v){
          __PO_HTML_LANG_SYNC__ = true;
          document.documentElement.setAttribute('lang', v);
          setTimeout(function(){ __PO_HTML_LANG_SYNC__ = false; }, 0);
        }
      }
    }catch(e){ __PO_HTML_LANG_SYNC__ = false; }
    return v;
  }

  function detectBrowserLang(){
    try{
      var dl = (document && document.documentElement) ? (document.documentElement.getAttribute('lang') || '') : '';
      var dln = normLang(dl);
      if (dln) return dln;
    }catch(e){}
    try{
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || '';
      var v = normLang(n);
      if (v) return v;
    }catch(e){}
    return 'fr';
  }

  function getLang(){
    return readStoredLang() || detectBrowserLang() || 'fr';
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event('po:locale-changed'));
    }catch(e){
      try{
        var ev = document.createEvent('Event');
        ev.initEvent('po:locale-changed', true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function getTargetBlocks(){
    var nodes = [];
    try{
      var all = document.querySelectorAll(ROOT_SEL);
      for (var i=0;i<all.length;i++){
        var id = '';
        try{ id = all[i].getAttribute('data-po-lex-id') || ''; }catch(e){ id = ''; }
        if (id === TARGET_ID) nodes.push(all[i]);
      }
    }catch(e){}
    return nodes;
  }

  /* --------------------------------------------------------------------------
   * LEXIQUE RUNTIME
   * -------------------------------------------------------------------------- */

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}
    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}
    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return '';
    try{ if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]); }catch(e){}
    return '';
  }

  function pickDefShort(entry, lang){
    if (!entry) return '';
    var ks = 'definition_short_' + lang;
    var k  = 'definition_' + lang;
    try{
      if (entry[ks]) return clampStr(entry[ks]);
      if (entry[k]) return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].short) return clampStr(entry.defs[lang].short);
    }catch(e){}
    return '';
  }

  function pickDefLong(entry, lang){
    if (!entry) return '';
    var kl = 'definition_long_' + lang;
    var k  = 'definition_' + lang;
    try{
      if (entry[kl]) return clampStr(entry[kl]);
      if (entry[k]) return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].long) return clampStr(entry.defs[lang].long);
    }catch(e){}
    return '';
  }

  function pickArray(entry, lang, base){
    if (!entry) return [];
    var k = base + '_' + lang;
    try{
      var v = entry[k];
      if (Array.isArray(v)) return v;
    }catch(e){}
    return [];
  }

  function pickAny(entry, key, fallback){
    try{ if (entry && entry[key] != null) return entry[key]; }catch(e){}
    return fallback;
  }

  /* --------------------------------------------------------------------------
   * PROTECTION FINE
   * -------------------------------------------------------------------------- */

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#39;');
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function uniqPush(arr, v, seen){
    var k = clampStr(v);
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, '’'), seen);
    uniqPush(out, t.replace(/œ/g, 'oe').replace(/Œ/g, 'OE'), seen);
    uniqPush(out, t.replace(/oe/g, 'œ').replace(/OE/g, 'Œ'), seen);

    var oe1 = t.replace(/œ/g, 'oe').replace(/Œ/g, 'OE');
    var oe2 = t.replace(/oe/g, 'œ').replace(/OE/g, 'Œ');
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, '’'), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, '’'), seen);
    return out;
  }

  function getSimplifiedLexiqueFRList(){
    var out = [];
    var seen = Object.create(null);

    function addMany(arr){
      if (!Array.isArray(arr)) return;
      for (var i=0;i<arr.length;i++) uniqPush(out, arr[i], seen);
    }

    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        addMany(window.PO_LEXICON_META.lexique_simplifie_fr);
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        addMany(window.PO_LEXICON.meta.lexique_simplifie_fr);
      }
    }catch(e){}
    addMany(CANON.page_terms);
    return out;
  }

  var __PO_PROTECT_CACHE__ = { key:'', re:null };

  function buildProtectMatcher(){
    var base = getSimplifiedLexiqueFRList();
    var variants = [];
    var seen = Object.create(null);
    for (var i=0;i<base.length;i++){
      var list = buildVariants(base[i]);
      for (var j=0;j<list.length;j++) uniqPush(variants, list[j], seen);
    }
    variants.sort(function(a,b){ return b.length - a.length; });
    var parts = [];
    for (var k=0;k<variants.length;k++) parts.push(escapeRegExp(variants[k]));
    if (!parts.length) return null;
    try{ return new RegExp('(' + parts.join('|') + ')', 'g'); }catch(e){ return null; }
  }

  function ensureProtectEngineReady(){
    var key = 'meta:none';
    try{ var l = getSimplifiedLexiqueFRList(); key = 'meta:' + (l ? l.length : 0); }catch(e){ key = 'meta:none'; }
    if (__PO_PROTECT_CACHE__.key === key) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectMatcher();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute('translate');
    if (tr && String(tr).toLowerCase() === 'no') return true;
    var cls = el.className || '';
    if (typeof cls === 'string'){
      if (cls.indexOf('notranslate') !== -1) return true;
      if (cls.indexOf('po-lex-protect') !== -1) return true;
      if (cls.indexOf('po-axis-audio-wrap') !== -1) return true;
      if (cls.indexOf('po-axis-audio-btn') !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch || '');
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;

    var txt = textNode.nodeValue;
    if (!txt) return;
    re.lastIndex = 0;
    if (!re.test(txt)) return;
    re.lastIndex = 0;

    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;
    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var hit = m[0];
      var end = start + hit.length;

      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));

      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : '';
      if (chPrev && isWordLikeChar(chPrev)) frag.appendChild(doc.createTextNode(' '));

      var span = doc.createElement('span');
      span.setAttribute('translate', 'no');
      span.className = 'po-lex-protect notranslate';
      span.textContent = hit;
      frag.appendChild(span);

      var chNext = (end < txt.length) ? txt.charAt(end) : '';
      if (chNext && isWordLikeChar(chNext)) frag.appendChild(doc.createTextNode(' '));

      last = end;
      if (hit.length === 0) break;
    }

    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsInElement(el){
    if (!el || !el.querySelectorAll) return;
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return;

    var walker;
    try{
      walker = document.createTreeWalker(
        el,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            var p = n.parentNode;
            var pn = p && p.nodeName ? p.nodeName : '';
            if (pn === 'SCRIPT' || pn === 'STYLE') return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return; }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
  }

  function protectKeywordsHTML(html){
    var s = clampStr(html);
    if (!s) return '';
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return s;

    var tpl = document.createElement('template');
    tpl.innerHTML = s;
    var root = tpl.content || tpl;
    var walker;
    try{
      walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return s; }

    var nodes = [];
    var t;
    while ((t = walker.nextNode())) nodes.push(t);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function htmlParagraphize(txt){
    var s = clampStr(txt);
    if (!s) return '';
    return '<p>' + escapeHTML(s).replace(/\n+/g, '</p><p>') + '</p>';
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== 'undefined' && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: '',
    speaking: false,
    utterance: null
  };

  var AUDIO_UI = {
    fr: { general: 'Écouter le texte', block: 'Écouter ce bloc', stop: 'Arrêter la lecture' },
    en: { general: 'Listen to the text', block: 'Listen to this section', stop: 'Stop playback' },
    es: { general: 'Escuchar el texto', block: 'Escuchar este bloque', stop: 'Detener la lectura' }
  };

  function audioUI(lang){
    var L = normLang(lang) || 'fr';
    return AUDIO_UI[L] || AUDIO_UI.fr;
  }

  function ensureAudioStyles(){
    if (document.getElementById('po-axis-audio-styles-usoprogalenmestud-20260303')) return;
    var st = document.createElement('style');
    st.id = 'po-axis-audio-styles-usoprogalenmestud-20260303';
    st.textContent = [
      '.po-axis-audio-wrap{display:flex;justify-content:center;margin:10px 0 12px;}',
      '.po-axis-audio-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;border:1px solid rgba(184,134,11,.45);border-radius:999px;padding:8px 12px;background:rgba(0,0,0,.02);font:inherit;font-weight:800;letter-spacing:.2px;cursor:pointer;user-select:none;-webkit-tap-highlight-color:transparent;box-shadow:0 0 0 1px rgba(184,134,11,.12),0 8px 18px rgba(31,122,58,.10);}',
      '.po-axis-audio-btn:hover{box-shadow:0 0 0 1px rgba(184,134,11,.24),0 10px 24px rgba(31,122,58,.14);}',
      '.po-axis-audio-btn.is-active{border-color:rgba(31,122,58,.55);box-shadow:0 0 0 1px rgba(31,122,58,.20),0 12px 28px rgba(31,122,58,.18);}',
      '.po-axis-audio-btn__label{color:var(--color-accent,#1f7a3a);}',
      '.po-lex-summary .po-axis-audio-btn{margin-left:auto;flex:0 0 auto;padding:6px 10px;font-size:12px;}',
      '.po-lex-summary .po-axis-audio-btn__label{white-space:nowrap;}',
      '@media (max-width:760px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-axis-audio-btn{order:3;width:100%;justify-content:center;margin-top:8px;}}'
    ].join('');
    document.head.appendChild(st);
  }

  function createAudioButton(role, index){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-axis-audio-btn';
    btn.setAttribute('data-po-audio-role', role);
    if (index != null) btn.setAttribute('data-po-audio-index', String(index));
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = '<span class="po-axis-audio-btn__label"></span>';
    return btn;
  }

  function getAudioButtonLabel(role, lang, isActive){
    var ui = audioUI(lang);
    if (isActive) return ui.stop;
    return role === 'general' ? ui.general : ui.block;
  }

  function updateAudioButtonLabel(btn, lang, isActive){
    if (!btn) return;
    var role = clampStr(btn.getAttribute('data-po-audio-role') || 'block');
    var label = btn.querySelector('.po-axis-audio-btn__label') || btn;
    label.textContent = getAudioButtonLabel(role, lang, !!isActive);
    btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    if (isActive) btn.classList.add('is-active'); else btn.classList.remove('is-active');
  }

  function updateAudioButtonsState(root, lang){
    if (!root) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn[data-po-audio-role]');
    var activeKey = (PO_AUDIO_STATE.root === root) ? PO_AUDIO_STATE.activeKey : '';
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      var role = clampStr(btn.getAttribute('data-po-audio-role') || 'block');
      var idx = clampStr(btn.getAttribute('data-po-audio-index') || '');
      var key = (role === 'general') ? 'general' : ('block-' + idx);
      updateAudioButtonLabel(btn, lang, key && key === activeKey && PO_AUDIO_STATE.speaking);
    }
  }

  function stopAudio(resetButtons){
    try{ if (PO_AUDIO_SYNTH) PO_AUDIO_SYNTH.cancel(); }catch(e){}
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.speaking = false;
    PO_AUDIO_STATE.utterance = null;
    if (resetButtons !== false){
      var roots = getTargetBlocks();
      for (var i=0;i<roots.length;i++) updateAudioButtonsState(roots[i], getLang());
    }
  }

  function cleanAudioText(s){
    return clampStr(s).replace(/\s+/g, ' ').replace(/[•·]+/g, '. ').replace(/\s([;:!?])/g, '$1').trim();
  }

  function collectTextFromNode(node){
    if (!node) return '';
    var clone = node.cloneNode(true);
    try{
      var kill = clone.querySelectorAll('.po-axis-audio-wrap, .po-axis-audio-btn, script, style, [aria-hidden="true"]');
      for (var i=0;i<kill.length;i++) if (kill[i] && kill[i].parentNode) kill[i].parentNode.removeChild(kill[i]);
    }catch(e){}
    return cleanAudioText(clone.textContent || '');
  }

  function buildGeneralText(root){
    var parts = [];
    var slots = ['title', 'kicker', 'h_def', 'def_short', 'def_long'];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector('[data-po-slot="' + slots[i] + '"]');
      var txt = collectTextFromNode(el);
      if (txt) parts.push(txt);
    }
    return cleanAudioText(parts.join('. '));
  }

  function buildDetailText(detail){
    if (!detail) return '';
    var parts = [];
    var title = detail.querySelector('.po-lex-summary__title');
    var titleTxt = collectTextFromNode(title);
    if (titleTxt) parts.push(titleTxt);

    var bodyClone = detail.cloneNode(true);
    try{
      var summary = bodyClone.querySelector('summary');
      if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
      var kill = bodyClone.querySelectorAll('.po-axis-audio-wrap, .po-axis-audio-btn, script, style');
      for (var i=0;i<kill.length;i++) if (kill[i] && kill[i].parentNode) kill[i].parentNode.removeChild(kill[i]);
    }catch(e){}
    var bodyTxt = cleanAudioText(bodyClone.textContent || '');
    if (bodyTxt) parts.push(bodyTxt);
    return cleanAudioText(parts.join('. '));
  }

  function splitTextForSpeech(text, limit){
    var maxLen = limit || 220;
    var raw = cleanAudioText(text);
    if (!raw) return [];
    var pieces = raw.match(/[^.!?;:…]+[.!?;:…]?/g) || [raw];
    var out = [];
    var current = '';
    for (var i=0;i<pieces.length;i++){
      var piece = cleanAudioText(pieces[i]);
      if (!piece) continue;
      if (((current ? current + ' ' : '') + piece).length > maxLen){
        if (current) out.push(current.trim());
        if (piece.length > maxLen){
          var words = piece.split(/\s+/);
          var acc = '';
          for (var j=0;j<words.length;j++){
            var w = words[j];
            if (!w) continue;
            var next = acc ? (acc + ' ' + w) : w;
            if (next.length > maxLen){
              if (acc) out.push(acc.trim());
              acc = w;
            } else acc = next;
          }
          current = acc || '';
        } else current = piece;
      } else current = current ? (current + ' ' + piece) : piece;
    }
    if (current) out.push(current.trim());
    return out;
  }

  function pickSpeechVoice(lang){
    if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== 'function') return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    if (!voices.length) return null;
    var code = normLang(lang || getLang()) || 'fr';
    var prefixes = code === 'fr' ? ['fr','fr-'] : (code === 'es' ? ['es','es-'] : ['en','en-']);
    for (var i=0;i<voices.length;i++){
      var vLang = clampStr(voices[i].lang).toLowerCase();
      if (!vLang) continue;
      for (var j=0;j<prefixes.length;j++) if (vLang === prefixes[j] || vLang.indexOf(prefixes[j]) === 0) return voices[i];
    }
    return voices[0] || null;
  }

  function buildAudioUnits(root, startKey){
    var units = [];
    if (!root) return units;
    var details = root.querySelectorAll('.po-lex-details');
    var startAt = 0;
    var useGeneral = (startKey === 'general');
    if (useGeneral){
      var generalTxt = buildGeneralText(root);
      if (generalTxt) units.push({ key:'general', kind:'general', text:generalTxt, detail:null });
      startAt = 0;
    } else {
      var parsed = parseInt(String(startKey || '').replace(/^block-/, ''), 10);
      startAt = isNaN(parsed) ? 0 : parsed;
    }
    for (var i=startAt;i<details.length;i++){
      var txt = buildDetailText(details[i]);
      if (txt) units.push({ key:'block-' + i, kind:'block', text:txt, detail:details[i] });
    }
    return units;
  }

  function openDetailIfNeeded(unit){
    if (!unit || unit.kind !== 'block' || !unit.detail) return;
    try{ unit.detail.open = true; }catch(e){}
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.speaking) return;
    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
        stopAudio(true);
        return;
      }
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      PO_AUDIO_STATE.activeKey = unit.key;
      PO_AUDIO_STATE.chunks = splitTextForSpeech(unit.text, 220);
      PO_AUDIO_STATE.chunkPos = -1;
      openDetailIfNeeded(unit);
      if (PO_AUDIO_STATE.root) updateAudioButtonsState(PO_AUDIO_STATE.root, getLang());
      if (!PO_AUDIO_STATE.chunks.length){ speakNextChunk(); return; }
      speakNextChunk();
      return;
    }
    var chunk = clampStr(PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos]);
    if (!chunk){ speakNextChunk(); return; }
    var utt;
    try{ utt = new SpeechSynthesisUtterance(chunk); }catch(e){ stopAudio(true); return; }
    var lang = getLang();
    utt.lang = lang === 'fr' ? 'fr-FR' : (lang === 'es' ? 'es-ES' : 'en-US');
    var voice = pickSpeechVoice(lang);
    if (voice) utt.voice = voice;
    utt.rate = 0.96;
    utt.pitch = 1;
    utt.volume = 1;
    utt.onend = function(){ PO_AUDIO_STATE.utterance = null; speakNextChunk(); };
    utt.onerror = function(){ PO_AUDIO_STATE.utterance = null; speakNextChunk(); };
    PO_AUDIO_STATE.utterance = utt;
    try{ PO_AUDIO_SYNTH.speak(utt); }catch(e){ stopAudio(true); }
  }

  function startAudio(root, startKey){
    if (!PO_AUDIO_SYNTH || !root) return;
    var sameRoot = (PO_AUDIO_STATE.root === root);
    var sameKey = (PO_AUDIO_STATE.activeKey === startKey);
    if (sameRoot && sameKey && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)){
      stopAudio(true);
      return;
    }
    stopAudio(false);
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildAudioUnits(root, startKey);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = startKey;
    PO_AUDIO_STATE.speaking = true;
    updateAudioButtonsState(root, getLang());
    speakNextChunk();
  }

  function bindAudioButton(btn, root){
    if (!btn || !root || btn.__poAudioBound) return;
    btn.addEventListener('click', function(ev){
      if (ev && typeof ev.preventDefault === 'function') ev.preventDefault();
      if (ev && typeof ev.stopPropagation === 'function') ev.stopPropagation();
      if (!PO_AUDIO_SYNTH) return;
      var role = clampStr(btn.getAttribute('data-po-audio-role') || 'block');
      var idx = clampStr(btn.getAttribute('data-po-audio-index') || '');
      var key = (role === 'general') ? 'general' : ('block-' + idx);
      startAudio(root, key);
    });
    btn.__poAudioBound = true;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();
    var panel = root.querySelector('.po-lex-panel');
    if (!panel) return;

    var generalWrap = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
    if (!generalWrap){
      generalWrap = document.createElement('div');
      generalWrap.className = 'po-axis-audio-wrap';
      generalWrap.setAttribute('data-po-audio-role', 'general');
      var generalBtn = createAudioButton('general');
      generalWrap.appendChild(generalBtn);
      var meta = root.querySelector('.po-axis-meta');
      var defShort = root.querySelector('[data-po-slot="def_short"]');
      var firstDetail = panel.querySelector('.po-lex-details');
      if (meta && meta.parentNode){
        if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling); else meta.parentNode.appendChild(generalWrap);
      } else if (defShort && defShort.parentNode){
        defShort.parentNode.insertBefore(generalWrap, defShort);
      } else if (firstDetail && firstDetail.parentNode){
        firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
      } else panel.appendChild(generalWrap);
    }

    var generalButton = generalWrap.querySelector('.po-axis-audio-btn[data-po-audio-role="general"]');
    if (!generalButton){
      generalButton = createAudioButton('general');
      generalWrap.appendChild(generalButton);
    }
    bindAudioButton(generalButton, root);

    var details = root.querySelectorAll('.po-lex-details');
    for (var i=0;i<details.length;i++){
      details[i].setAttribute('data-po-audio-index', String(i));
      var summary = details[i].querySelector('.po-lex-summary');
      if (!summary) continue;
      var btn = summary.querySelector('.po-axis-audio-btn[data-po-audio-role="block"]');
      if (!btn){
        btn = createAudioButton('block', i);
        summary.appendChild(btn);
      } else btn.setAttribute('data-po-audio-index', String(i));
      bindAudioButton(btn, root);
    }

    updateAudioButtonsState(root, lang || getLang());
  }

  function initAudioEverywhere(lang){
    var l = normLang(lang || getLang()) || 'fr';
    var roots = getTargetBlocks();
    for (var i=0;i<roots.length;i++) ensureAudioButtons(roots[i], l);
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.getVoices === 'function'){
      PO_AUDIO_SYNTH.onvoiceschanged = function(){
        try{ initAudioEverywhere(getLang()); }catch(e){}
      };
    }
  }catch(e){}

  /* --------------------------------------------------------------------------
   * FALLBACKS Ušôprogalenmestûd
   * -------------------------------------------------------------------------- */

  var FALLBACK_FR = {
    title: CANON.title,
    kicker: 'Extrait du <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(organe interne de La Katûvýs ; vortex de passage)',
    cta_translate: 'Proposer une traduction du concept',
    h_def: 'Définition opérative',
    chips: ['Élément', 'Totem', 'Fréquence'],
    title_img: IMG_IDEOGRAM_CONCEPT,
    chip_urls: [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_225],
    def_short: 'Vortex de modulation transitoire, seuil mobile. Ouvre la déliaison juste : accompagne l’instant où une forme se défait pour se reconfigurer. Rend la transition respirable, soutient la traversée, installe une tenue provisoire du passage.',
    def_long:
      'La genèse d’une matrice de seuil.\n\n' +
      'Ušôprogalenmestûd se présente comme une unité vibratoire active du système posœnnoïal, opérant au sein de La Katûvýs comme modulateur spiralé transitoire. Il incarne une fonction de traversée rituelle, transductive et symbolique, sollicitée aux seuils de passage entre plans de perception, d’intention ou de mémoire. Sa présence prend la forme d’une onde de modulation, activée lors de reconfigurations sensibles, poétiques ou spirituelles, et portée par une dynamique d’apparition, de variation et de retrait selon l’état du champ.\n\n' +
      'Sa structure lexicale concentre une tension fluide entre une substance opérante inaugurale (Ušô), un élan orienté (progalen) et une émergence stabilisée de manière transitoire (mestûd). Le terme configure ainsi une force de désarticulation suivie de recomposition : l’ajustement d’un champ vibratoire, d’une œuvre, d’un rituel ou d’une pensée à un nouveau contexte de résonance devient praticable, lisible et opérable.\n\n' +
      'Associé au nombre-guide 225, carré de 15 et somme numérique de 9, Ušôprogalenmestûd agit dans une dynamique de transmission spiralée, où la structure se maintient dans un régime de réajustement par tension, boucle et passage. Il joue comme activateur de vortex : l’action s’exerce par ouverture, calibration et modulation des fréquences d’interconnexion, dans une intelligence du seuil et du moment. Son totem, Êkhö, désigne une résonance autonome, vivante, écosophique, traversante, ajustante. Êkhö travaille par transformation : modulation, amplification, réduction, selon les besoins de l’instant et la pression du champ. Ce totem éclaire la capacité d’Ušôprogalenmestûd à agir sur les milieux par syntonie, à épouser les intensités, à conduire les passages, à soutenir la mobilité opérative du seuil.',
    h_features: 'Déploiement',
    h_questions: 'Tests d’usage',
    hint_fold: 'déplier',
    example_title: 'Exemple opératif',
    example: '1) Si une mutation demande un seuil vivant (délier/relier), nomme Ušôprogalenmestûd. 2) Si tu veux « tenir la transition » sans la durcir : « Ušôprogalenmestûd tient le seuil ». 3) Quand une œuvre, une pensée ou un rituel bascule de régime et que la recomposition doit rester praticable : « j’active Ušôprogalenmestûd ».',
    features: [
      'Statut canonique : organe/vortex de passage de La Katûvýs ; unité vibratoire active de Katûsýs ; modulateur spiralé transitoire.',
      'Fonction principale : vortex de modulation transitoire, pont vibratoire entre états, catalyseur d’ajustement entre plans de perception, d’intention et de mémoire.',
      'Champ d’activation : phases de mutation, crise de forme, rituel de passage, désancrage symbolique, reconfiguration sensible, poïétique ou spirituelle.',
      'Totem : Êkhö — résonance autonome, vivante, écosophique, traversante, ajustante ; agit par modulation, amplification et réduction selon la pression du champ.',
      'Fréquence 225 : 15² ; densification rythmique, oscillation 2–2–5, transmission spiralée et relance par réduction 9.'
    ],
    questions: [
      'La transformation en cours requiert-elle une tenue provisoire du seuil plutôt qu’une stabilisation définitive ?',
      'Suis-je au point où une forme se défait avant recomposition et faut-il rendre la déliaison praticable ?',
      'Quel plan bascule : perception, intention, mémoire, symbolique, poïétique ?',
      'Le champ exige-t-il une modulation, une calibration ou une suspension momentanée d’une séquence vibratoire ?'
    ],
    h_family: 'Position & relations',
    family_1: '<p><strong>Position systémique :</strong> Ušôprogalenmestûd appartient à <strong>Katûsýs</strong>, bande interne où s’expriment les unités actives de <strong>La Katûvýs</strong>. Il intervient comme agent de seuil : il ouvre un canal, catalyse une transition, rend la traversée praticable lorsque le champ se tend vers une mutation.</p>',
    family_2: '<p><strong>Relations prioritaires :</strong> Ušôprogalenmestûd entretient une relation de syntonie vibratoire avec <strong>Mathêsis ontologique posœnnoïale</strong> (<strong>MOPo</strong>) dans les zones de tension ou de mutation perceptive ; résonance avec <strong>Katûvýsissence</strong> comme registre mémoriel des passages ; interaction avec <strong>Takimarah</strong>, <strong>Tiqqunbahu</strong> et les <strong>Accords posœnnoïaux</strong> dans les phases de mutation.</p>',
    h_wordbuild: 'Construction du concept (segments attestables + addition synchrêtique)',
    word_blocks: [
      {
        head: 'Architecture translinguistique',
        text: 'Uš (sumérien uš) : substance opérante, matière rituelle d’efficacité. ô (grec ὦ) : interjection vocative, intensification de l’appel. pro (latin prō / pro-) : orientation vers l’avant, projection. galen (grec γαλήνη/γαληνός) : calme après l’agitation, régulation fluide. mes (grec μέσος) : milieu, centre, nœud de modulation. tûd (sumérien tud/tu(d)) : enfanter, faire naître, avènement opératif.'
      },
      {
        head: 'Lecture opérative',
        text: 'La substance-énergie (Uš) est appelée (ô), orientée (pro), régulée (galen), tenue au milieu (mes), puis portée à l’avènement (tûd) : onde de passage et stabilisation provisoire au cœur de La Katûvýs.'
      },
      {
        head: 'Fréquence 225',
        text: 'Le premier 2 figure l’oscillation entre polarités ; le second 2 intensifie la tension par effet de miroir ; le 5 agit comme catalyseur spiralé de régénération et d’adaptation. 15² = 225 : densification rythmique et trame structurante modulaire. 2 + 2 + 5 = 9 : transmission fluide, seuil prêt à être recomposé, fréquence d’ouverture transformatrice.'
      }
    ],
    word_notes: [
      'Élément : La Katûvýs ; Totem : Êkhö ; Fréquence (nombre-guide) : 225.',
      'Nom du seuil mobile ; modulation vive ; traversée poïétique où la transformation se prépare, se décide et se déploie.',
      'Le titre reste en FR (terme du lexique), quelle que soit la langue de l’interface.'
    ]
  };

  var FALLBACK_EN = {
    title: CANON.title,
    kicker: 'Excerpt from <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(internal organ of La Katûvýs; passage vortex)',
    cta_translate: 'Suggest a translation of the concept',
    h_def: 'Operative definition',
    chips: ['Element', 'Totem', 'Frequency'],
    title_img: IMG_IDEOGRAM_CONCEPT,
    chip_urls: [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_225],
    def_short: 'Vortex of transitory modulation, mobile threshold. It opens the right unbinding: it accompanies the instant when a form unravels in order to reconfigure. It makes the transition breathable, supports the crossing, and installs a provisional holding of the passage.',
    def_long:
      'La genèse d’une matrice de seuil.\n\n' +
      CANON.title + ' presents itself as an active vibratory unit of the posœnnoïal system, operating within La Katûvýs as a transitory spiral modulator. It embodies a function of ritual, transductive and symbolic crossing, called upon at thresholds between planes of perception, intention and memory.\n\n' +
      'Its lexical structure concentrates a fluid tension between an inaugural operative substance (Ušô), an oriented impulse (progalen) and an emergence stabilized in a transitory way (mestûd). The term configures a force of disarticulation followed by recomposition: the adjustment of a vibratory field, an artwork, a ritual or a thought to a new context of resonance becomes practicable, readable and operable.\n\n' +
      'Associated with the nombre-guide 225, square of 15 and sum of 9, ' + CANON.title + ' acts within a dynamic of spiral transmission where structure maintains itself through readjustment, tension, loop and passage. Its totem, Êkhö, names an autonomous, living, ecosophic, traversing and adjusting resonance.',
    h_features: 'Unfolding',
    h_questions: 'Use tests',
    hint_fold: 'expand',
    example_title: 'Operative example',
    example: '1) If a mutation requires a living threshold (unbind/rebind), name Ušôprogalenmestûd. 2) If you want to hold the transition without hardening it: “Ušôprogalenmestûd holds the threshold.” 3) When an artwork, a thought or a ritual shifts regime and recomposition must remain workable: “I activate Ušôprogalenmestûd.”',
    features: [
      'Canonical status: passage organ/vortex of La Katûvýs; active vibratory unit of Katûsýs; transitory spiral modulator.',
      'Main function: vortex of transitory modulation, vibratory bridge between states, catalyst of adjustment between planes of perception, intention and memory.',
      'Activation field: phases of mutation, crisis of form, rite of passage, symbolic unmooring, sensitive, poietic or spiritual reconfiguration.',
      'Totem: Êkhö — autonomous, living, ecosophic, traversing and adjusting resonance; acts through modulation, amplification and reduction according to the pressure of the field.',
      'Frequency 225: 15²; rhythmic densification, 2–2–5 oscillation, spiral transmission and relaunch by reduction 9.'
    ],
    questions: [
      'Does the transformation require a provisional holding of the threshold rather than a definitive stabilization?',
      'Am I at the point where a form unravels before recomposition, and must the unbinding be made workable?',
      'Which plane is shifting: perception, intention, memory, symbolic, poietic?',
      'Does the field require modulation, calibration or temporary suspension of a vibratory sequence?'
    ],
    h_family: 'Position & relations',
    family_1: '<p><strong>Systemic position:</strong> Ušôprogalenmestûd belongs to <strong>Katûsýs</strong>, the inner band where the active units of <strong>La Katûvýs</strong> are expressed. It acts as an agent of threshold: it opens a channel, catalyzes a transition and makes the crossing workable when the field tends toward mutation.</p>',
    family_2: '<p><strong>Priority relations:</strong> Ušôprogalenmestûd maintains a relation of vibratory syntony with <strong>Mathêsis ontologique posœnnoïale</strong> (<strong>MOPo</strong>) in zones of tension or perceptive mutation; resonance with <strong>Katûvýsissence</strong> as memorial register of passages; interaction with <strong>Takimarah</strong>, <strong>Tiqqunbahu</strong> and the <strong>Accords posœnnoïaux</strong> in phases of mutation.</p>',
    h_wordbuild: 'Concept building (attestable segments + addition synchrêtique)',
    word_blocks: [
      {
        head: 'Translinguistic architecture',
        text: 'Uš (Sumerian uš): operative substance, ritual material of efficacy. ô (Greek ὦ): vocative interjection, intensification of the call. pro (Latin prō / pro-): forward orientation, projection. galen (Greek γαλήνη/γαληνός): calm after agitation, fluid regulation. mes (Greek μέσος): middle, center, modulation node. tûd (Sumerian tud/tu(d)): to give birth, operative advent.'
      },
      {
        head: 'Operative reading',
        text: 'The substance-energy (Uš) is called (ô), oriented (pro), regulated (galen), held in the middle (mes), and brought to advent (tûd): a passage-wave and provisional stabilization at the heart of La Katûvýs.'
      },
      {
        head: 'Frequency 225',
        text: 'The first 2 figures oscillation between polarities; the second 2 intensifies tension through mirror effect; 5 acts as a spiral catalyst of regeneration and adaptation. 15² = 225: rhythmic densification and modular structuring weave. 2 + 2 + 5 = 9: fluid transmission, threshold ready to be recomposed, frequency of transformative opening.'
      }
    ],
    word_notes: [
      'Élément: La Katûvýs; Totem: Êkhö; Frequency (nombre-guide): 225.',
      'Name of the mobile threshold; vivid modulation; poietic crossing where transformation is prepared, decided and deployed.',
      'Title remains FR (lexicon term) whatever the UI language.'
    ]
  };

  var FALLBACK_ES = {
    title: CANON.title,
    kicker: 'Extracto de <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(órgano interno de La Katûvýs; vórtice de pasaje)',
    cta_translate: 'Proponer una traducción del concepto',
    h_def: 'Definición operativa',
    chips: ['Elemento', 'Tótem', 'Frecuencia'],
    title_img: IMG_IDEOGRAM_CONCEPT,
    chip_urls: [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_225],
    def_short: 'Vórtice de modulación transitoria, umbral móvil. Abre la desligazón justa: acompaña el instante en que una forma se deshace para reconfigurarse. Vuelve respirable la transición, sostiene la travesía e instala una tenida provisional del pasaje.',
    def_long:
      'La genèse d’une matrice de seuil.\n\n' +
      CANON.title + ' se presenta como una unidad vibratoria activa del sistema posœnnoïal, operando en La Katûvýs como modulador espiral transitorio. Encierra una función de travesía ritual, transductiva y simbólica, solicitada en umbrales entre planos de percepción, intención y memoria.\n\n' +
      'Su estructura lexical concentra una tensión fluida entre una sustancia operante inaugural (Ušô), un impulso orientado (progalen) y una emergencia estabilizada de manera transitoria (mestûd). El término configura una fuerza de desarticulación seguida de recomposición: el ajuste de un campo vibratorio, de una obra, de un ritual o de un pensamiento a un nuevo contexto de resonancia se vuelve practicable, legible y operable.\n\n' +
      'Asociado al nombre-guide 225, cuadrado de 15 y suma de 9, ' + CANON.title + ' actúa dentro de una dinámica de transmisión espiral. Su tótem, Êkhö, nombra una resonancia autónoma, viva, ecosófica, atravesante y ajustante.',
    h_features: 'Despliegue',
    h_questions: 'Pruebas de uso',
    hint_fold: 'desplegar',
    example_title: 'Ejemplo operativo',
    example: '1) Si una mutación exige un umbral vivo (desligar/religar), nombra Ušôprogalenmestûd. 2) Si quieres sostener la transición sin endurecerla: « Ušôprogalenmestûd tient le seuil ». 3) Cuando una obra, un pensamiento o un ritual cambia de régimen y la recomposición debe seguir siendo practicable: « j’active Ušôprogalenmestûd ».',
    features: [
      'Estatus canónico: órgano/vórtice de pasaje de La Katûvýs; unidad vibratoria activa de Katûsýs; modulador espiral transitorio.',
      'Función principal: vórtice de modulación transitoria, puente vibratorio entre estados, catalizador de ajuste entre planos de percepción, intención y memoria.',
      'Campo de activación: fases de mutación, crisis de forma, rito de pasaje, desanclaje simbólico, reconfiguración sensible, poietica o espiritual.',
      'Tótem: Êkhö — resonancia autónoma, viva, ecosófica, atravesante y ajustante; actúa por modulación, amplificación y reducción según la presión del campo.',
      'Frecuencia 225: 15²; densificación rítmica, oscilación 2–2–5, transmisión espiral y relance por reducción 9.'
    ],
    questions: [
      '¿La transformación requiere una tenida provisional del umbral más que una estabilización definitiva?',
      '¿Estoy en el punto donde una forma se deshace antes de recomponerse y la desligazón debe volverse practicable?',
      '¿Qué plano bascula: percepción, intención, memoria, simbólico, poiético?',
      '¿El campo exige modulación, calibración o suspensión momentánea de una secuencia vibratoria?'
    ],
    h_family: 'Posición y relaciones',
    family_1: '<p><strong>Posición sistémica:</strong> Ušôprogalenmestûd pertenece a <strong>Katûsýs</strong>, banda interna donde se expresan las unidades activas de <strong>La Katûvýs</strong>. Actúa como agente de umbral: abre un canal, cataliza una transición y vuelve practicable la travesía cuando el campo tiende hacia una mutación.</p>',
    family_2: '<p><strong>Relaciones prioritarias:</strong> Ušôprogalenmestûd mantiene una relación de sintonía vibratoria con <strong>Mathêsis ontologique posœnnoïale</strong> (<strong>MOPo</strong>) en las zonas de tensión o de mutación perceptiva; resuena con <strong>Katûvýsissence</strong> como registro memorial de los pasajes; interactúa con <strong>Takimarah</strong>, <strong>Tiqqunbahu</strong> y los <strong>Accords posœnnoïaux</strong> en las fases de mutación.</p>',
    h_wordbuild: 'Construcción del concepto (segmentos atestables + addition synchrêtique)',
    word_blocks: [
      {
        head: 'Arquitectura translingüística',
        text: 'Uš (sumerio uš): sustancia operante, materia ritual de eficacia. ô (griego ὦ): interjección vocativa, intensificación del llamado. pro (latín prō / pro-): orientación hacia adelante, proyección. galen (griego γαλήνη/γαληνός): calma tras la agitación, regulación fluida. mes (griego μέσος): medio, centro, nudo de modulación. tûd (sumerio tud/tu(d)): dar a luz, advenimiento operativo.'
      },
      {
        head: 'Lectura operativa',
        text: 'La sustancia-energía (Uš) es llamada (ô), orientada (pro), regulada (galen), sostenida en el medio (mes) y llevada al advenimiento (tûd): una onda de pasaje y una estabilización provisional en el corazón de La Katûvýs.'
      },
      {
        head: 'Frecuencia 225',
        text: 'El primer 2 figura la oscilación entre polaridades; el segundo 2 intensifica la tensión por efecto espejo; el 5 actúa como catalizador espiral de regeneración y adaptación. 15² = 225: densificación rítmica y trama estructurante modular. 2 + 2 + 5 = 9: transmisión fluida, umbral listo para recomponerse, frecuencia de apertura transformadora.'
      }
    ],
    word_notes: [
      'Élément: La Katûvýs; Totem: Êkhö; Frecuencia (nombre-guide): 225.',
      'Nombre del umbral móvil; modulación viva; travesía poiética donde la transformación se prepara, se decide y se despliega.',
      'El título permanece en FR (término del léxico) cualquiera que sea la lengua de la interfaz.'
    ]
  };

  function getFallback(lang){
    var l = normLang(lang) || 'fr';
    if (l === 'en') return FALLBACK_EN;
    if (l === 'es') return FALLBACK_ES;
    return FALLBACK_FR;
  }

  function getAxisLexId(node){
    try{ return node.getAttribute('data-po-lex-id') || ''; }catch(e){ return ''; }
  }

  function lockNode(el){
    if (!el || !el.setAttribute) return;
    try{ el.setAttribute('translate', 'no'); }catch(e){}
    try{ if (el.classList){ el.classList.add('notranslate'); el.classList.add('po-lex-slotlock'); } }catch(e){}
  }

  function normalizeCanonicalFrench(text){
    var s = clampStr(text);
    if (!s) return s;
    s = s.replace(/\bguide-number\b/gi, 'nombre-guide');
    s = s.replace(/\bn[uú]mero-gu[ií]a\b/gi, 'nombre-guide');
    s = s.replace(/\bsyncretic addition\b/gi, 'addition synchrêtique');
    s = s.replace(/\badi[cç][ií]on sincr[eé]tica\b/gi, 'addition synchrêtique');
    s = s.replace(/\bsyncretic\b/gi, 'synchrêtique');
    s = s.replace(/\bsincr[eé]tic[ao]?\b/gi, 'synchrêtique');
    s = s.replace(/\bMathêsis ontological posœnnoïale\b/g, 'Mathêsis ontologique posœnnoïale');
    s = s.replace(/\bMathêsis ontológica posœnnoïale\b/g, 'Mathêsis ontologique posœnnoïale');
    return s;
  }

  function firstNonEmpty(){
    for (var i=0;i<arguments.length;i++){
      var v = arguments[i];
      if (Array.isArray(v)){
        if (v.length) return v;
      } else if (clampStr(v)) return v;
    }
    return Array.isArray(arguments[0]) ? [] : '';
  }

  function getAxisData(node, lang){
    var l = normLang(lang) || 'fr';
    var base = getFallback(l);
    var out = {};
    for (var k in base) out[k] = base[k];
    var lexId = getAxisLexId(node);
    var entry = lexId ? getLexiconEntry(lexId) : null;

    out.title = CANON.title;
    if (entry){
      var frTerm = firstNonEmpty(pickTerm(entry, 'fr'), CANON.title);
      out.title = frTerm;
      if (l === 'fr'){
        out.def_short = firstNonEmpty(pickDefShort(entry, 'fr'), out.def_short);
        out.def_long = firstNonEmpty(pickDefLong(entry, 'fr'), out.def_long);
        out.features = firstNonEmpty(pickArray(entry, 'fr', 'features'), pickArray(entry, 'fr', 'characteristics'), out.features);
        out.questions = firstNonEmpty(pickArray(entry, 'fr', 'questions'), pickArray(entry, 'fr', 'usage_questions'), out.questions);
      }
      out.kicker = firstNonEmpty(pickAny(entry, 'kicker_fr', ''), pickAny(entry, 'kicker', ''), out.kicker);
    }

    out.title = CANON.title;
    out.title_img = base.title_img || IMG_IDEOGRAM_CONCEPT;
    out.chip_urls = base.chip_urls || [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_225];
    out.def_short = normalizeCanonicalFrench(out.def_short);
    out.def_long = normalizeCanonicalFrench(out.def_long);
    return out;
  }

  function qs(root, sel){ try{ return root.querySelector(sel); }catch(e){ return null; } }

  function setSlotText(root, slot, txt){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    el.textContent = normalizeCanonicalFrench(clampStr(txt));
  }

  function setSlotHTML(root, slot, html){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    el.innerHTML = protectKeywordsHTML(normalizeCanonicalFrench(clampStr(html)));
    protectKeywordsInElement(el);
  }

  function setSlotImg(root, slot, src, alt){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var s = clampStr(src), a = clampStr(alt);
    if (!s){
      try{ el.removeAttribute('src'); }catch(e){}
      try{ el.setAttribute('alt', ''); }catch(e){}
      try{ el.style.visibility = 'hidden'; }catch(e){}
      return;
    }
    try{ el.setAttribute('src', s); }catch(e){}
    try{ el.setAttribute('alt', a); }catch(e){}
    try{ el.style.visibility = ''; }catch(e){}
  }

  function setSlotImgSrc(root, slot, src, alt){ setSlotImg(root, slot, src, alt); }

  function renderList(root, slot, items){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++) out.push('<li>' + protectKeywordsHTML(normalizeCanonicalFrench(clampStr(arr[i]))) + '</li>');
    el.innerHTML = out.join('');
    protectKeywordsInElement(el);
  }

  function renderExampleBox(root, slot, exampleTitle, exampleText){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    var t = normalizeCanonicalFrench(clampStr(exampleTitle));
    var x = normalizeCanonicalFrench(clampStr(exampleText));
    if (!t && !x){ el.innerHTML = ''; return; }
    el.innerHTML = '<div class="po-lex-example__title"><strong>' + protectKeywordsHTML(t) + '</strong></div>' +
      '<div class="po-lex-example__text">' + protectKeywordsHTML(x) + '</div>';
    protectKeywordsInElement(el);
  }

  function renderWordBlocks(root, slot, blocks){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      out.push('<div class="po-axis-wb"><div class="po-axis-wb__h">' + protectKeywordsHTML(normalizeCanonicalFrench(clampStr(b.head))) + '</div><div class="po-axis-wb__t">' + protectKeywordsHTML(normalizeCanonicalFrench(clampStr(b.text))).replace(/\n/g, '<br />') + '</div></div>');
    }
    el.innerHTML = out.join('');
    protectKeywordsInElement(el);
  }

  function applyToAxis(node, lang){
    var data = getAxisData(node, lang);
    var chipUrls = Array.isArray(data.chip_urls) ? data.chip_urls : [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_225];
    setSlotImgSrc(node, 'title_img', data.title_img || IMG_IDEOGRAM_CONCEPT, data.title || CANON.title);
    setSlotText(node, 'title', data.title || CANON.title);
    setSlotHTML(node, 'kicker', data.kicker || '');
    setSlotText(node, 'h_def', data.h_def || '');

    var chips = Array.isArray(data.chips) ? data.chips : [];
    setSlotText(node, 'chip_1', chips[0] || '');
    setSlotText(node, 'chip_2', chips[1] || '');
    setSlotText(node, 'chip_3', chips[2] || '');
    setSlotImgSrc(node, 'chip_1_img', chipUrls[0] || IMG_ELEMENT, chips[0] || '');
    setSlotImgSrc(node, 'chip_2_img', chipUrls[1] || IMG_TOTEM, chips[1] || '');
    setSlotImgSrc(node, 'chip_3_img', chipUrls[2] || IMG_FREQ_225, chips[2] || '');

    setSlotHTML(node, 'def_short', htmlParagraphize(data.def_short || ''));
    setSlotHTML(node, 'def_long', htmlParagraphize(data.def_long || ''));

    setSlotText(node, 'h_features', data.h_features || '');
    setSlotText(node, 'hint_fold', data.hint_fold || '');
    renderList(node, 'features', data.features || []);

    setSlotText(node, 'h_questions', data.h_questions || '');
    setSlotText(node, 'hint_fold2', data.hint_fold || '');
    renderList(node, 'questions', data.questions || []);
    renderExampleBox(node, 'example_box', data.example_title || '', data.example || '');

    setSlotText(node, 'h_family', data.h_family || '');
    setSlotText(node, 'hint_fold3', data.hint_fold || '');
    setSlotHTML(node, 'family_1', data.family_1 || '');
    setSlotHTML(node, 'family_2', data.family_2 || '');

    setSlotText(node, 'h_wordbuild', data.h_wordbuild || '');
    renderWordBlocks(node, 'wordbuild_blocks', data.word_blocks || []);
    renderList(node, 'wordbuild_notes', data.word_notes || []);

    setSlotText(node, 'cta_translate', data.cta_translate || '');
  }

  function applyLangEverywhere(lang){
    var l = normLang(lang) || getLang() || 'fr';
    storeLang(l);
    var roots = getTargetBlocks();
    for (var i=0;i<roots.length;i++) applyToAxis(roots[i], l);
    initAudioEverywhere(l);
    notifyLocaleChanged();
    return l;
  }

  function hasLexiconReady(){
    try{
      if (window.PO_LEXICON_MAP) return true;
      if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true;
      if (window.PO_LEXICON_META && window.PO_LEXICON_META.lexique_simplifie_fr) return true;
    }catch(e){}
    return false;
  }

  var __PO_USO_WATCHERS_SET__ = false;

  function setupWatchers(){
    if (__PO_USO_WATCHERS_SET__) return;
    __PO_USO_WATCHERS_SET__ = true;
    window.addEventListener('po:lexicon-ready', function(){
      __PO_PROTECT_CACHE__.key = '';
      __PO_PROTECT_CACHE__.re = null;
      applyLangEverywhere(getLang());
    });
  }

  function init(){
    setupWatchers();
    var existing = readStoredLang();
    if (!existing) storeLang(detectBrowserLang());
    applyLangEverywhere(getLang());
    if (!hasLexiconReady()){
      var tries = 0;
      var maxTries = 24;
      var it = setInterval(function(){
        tries++;
        if (hasLexiconReady() || tries >= maxTries){
          clearInterval(it);
          __PO_PROTECT_CACHE__.key = '';
          __PO_PROTECT_CACHE__.re = null;
          applyLangEverywhere(getLang());
        }
      }, 250);
    }
  }

  window.PoKatupirsia5UsoprogalenmestudTextsFR_EN_ES_20260303 = {
    init: init,
    getLang: getLang,
    normLang: normLang,
    setLang: function(raw){
      var l = normLang(raw) || 'fr';
      return applyLangEverywhere(l);
    },
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.init = init;
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = function(lang){ return window.PoKatupirsia5UsoprogalenmestudTextsFR_EN_ES_20260303.setLang(lang); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
